export const AVATAR = {
  SIZE: { LG: "180px", SM: "120px" },
};

export const BUTTON_SX = {
  DISABLED: {
    "&:disabled": {
      backgroundColor: "primary.900",
      color: "primary.main",
    },
  },
};

export const DASH = "-";

export const MAINTENANCE = {
  GRAPH_HEIGHT: 500,
};

export const MARGIN_GAP = 4;

export const NAVBAR = {
  HEIGHT: 65,
  ICON_POSITIONING: 10,
  ICON_SIZE: 6,
  MARGIN_BOTTOM: 6,
};

export const RING_SIZE = 400;

export const STATS = {
  ICON_SIZE: "28px",
  VALUE_CIRCLE: "24px",
};

export const STATS_CHART = {
  MAX: 20,
  MIN: 1,
};

export const PAGE_TITLE_SX = { fontSize: { xs: "1.5rem", sm: "1.7rem" } };

export const PAGE_CONTAINER_SX = {
  display: "flex",
  flexDirection: "column",
  gap: MARGIN_GAP,
  pb: MARGIN_GAP * 2,
};

export const PAGE_LIST_CONTAINER_SX = {
  pb: MARGIN_GAP * 2,
};

export const SESSION_STORAGE_USER_KEY = "aleph";

export const ROUTES = {
  BASE: "/:id",
  HOME: "/home",
  HOST_BACKGROUND: "background",
  HOST_STATS: "stats",
  HOST_EVENTS: "events",
  HOST_LOG: "log",
  PLOTS: {
    BASE: "plots",
    PLOTS: {
      BASE: "plots",
      DETAIL: "plots/:id",
      CREATE: "plots/create",
    },
    CHARACTERS: {
      BASE: "characters",
      DETAIL: "characters/:id",
      CREATE: "characters/create",
    },
    EVENTS: {
      BASE: "events",
    },
  },
  BEHAVIOUR: {
    BASE: "behaviour",
    DETAIL: "behaviour/:id",
  },
  MAINTENANCE: {
    BASE: "maintenance",
    DETAIL: "maintenance/:id",
  },
  SECURITY: {
    BASE: "security",
    HOSTS: {
      BASE: "hosts",
      DETAIL: "hosts/:id",
    },
    EMPLOYEES: {
      BASE: "employees",
      DETAIL: "employees/:id",
    },
  },
  RUNS: {
    BASE: "runs",
    DETAIL: "runs/:id",
  },
  HOSTS: {
    BASE: "hosts",
  },
};

export const HOST_STATUS = {
  DEAD: "dead",
  HURT: "needs_repair",
  OK: "ok",
};

export const LOG_TYPES = {
  ASSIGN: "CHARACTER_ASSIGNED",
  CREATE: "CHARACTER_CREATED",
  EDIT: "CHARACTER_EDITED",
  STAT: "STAT_CHANGED",
  STATUS: "STATUS_CHANGED",
};

export const DEFAULT_PASSWORD = "123456";

export const USER_PROFILE = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
  HOST: "host",
};
